import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

export const sanctuaryLiteApi = createApi({
  reducerPath: "sanctuaryLiteApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/", // same-origin: the UI is served by the same Express app as the API
    prepareHeaders: (headers) => {
      const token = JSON.parse(localStorage.getItem("user") || "").token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
  }),
  endpoints: (builder) => ({
    getSanctuaryLiteEntries: builder.mutation({
      query: () => {
        return {
          url: `/sanctuaryLiteEarlyAccess/`,
          method: "get",
        };
      },
      transformResponse: (response) => response.data,
      transformErrorResponse: (response) => response.data,
    }),
  }),
});

export const { useGetSanctuaryLiteEntriesMutation } = sanctuaryLiteApi;
